import { 
  Paper, 
  Box, 
  Grid, 
  Typography, 
} from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import JobsDataTable from './JobsDataTable';
import dateSub from 'date-fns/sub';
import dateFormat from 'date-fns/format';
import useServiceRequestSearch, { QueryVars, RequestGroup } from '../hooks/useServiceRequestSearch';
import { Job } from '../JobTypes';

const PAGE_SIZE: number = 10;
const CURRENT_DATE: Date = new Date();

interface Props {
  title?: string
  jobGroup: RequestGroup
}

const JobsOverdueWidget: React.FC<Props> = ({title, jobGroup}) => {
  const classes = useStyles();
  const QUERY_VARS: QueryVars = {
    search: {
      requestGroups: [ jobGroup ],
      dateReceivedFrom: dateFormat(dateSub(CURRENT_DATE,{days:7}), "yyyy-MM-dd'T'00:00:00"),
      dateReceivedTo: dateFormat(dateSub(CURRENT_DATE,{days:2}), "yyyy-MM-dd'T'HH:mm:ss"),
    },
  };
  const [currentPage, setCurrentPage] = React.useState<number>(0);
  const [jobsOnPage, setJobsOnPage] = React.useState<Job[]>([]);
  const { loading, error, jobData, resultCount } = useServiceRequestSearch(QUERY_VARS);

  React.useEffect(()=>{
    if(!jobData)
      return;

    setJobsOnPage(jobData.slice(currentPage * PAGE_SIZE,(currentPage * PAGE_SIZE + PAGE_SIZE)));
  },[currentPage,jobData]);

  const handlePageChange = (_event: Event, pageNumber: number) => {
    setCurrentPage(pageNumber);
  }

  return (
    <Paper className={classes.root} square>
      <Box px={4} py={3}>
        <Grid container alignContent="stretch">
          <Grid item xs={4}>
            <Typography className={classes.widgetTitle} component="h2">{title || 'Overdue Jobs'}</Typography>
          </Grid>
          <Grid className={classes.widgetFilters} item container xs={8} justify="flex-end" spacing={2}>
          </Grid>
        </Grid>
      </Box>
      { error && <div>{error.message}</div> }
      { jobData && 
        <JobsDataTable 
          data={loading ? [] : jobsOnPage} 
          handlePageChange={handlePageChange} 
          currentPage={currentPage}
          pageSize={PAGE_SIZE}
          count={loading ? 0 : resultCount}
          loading={loading}
        /> }
    </Paper>
  );
}

const useStyles = makeStyles((theme) => ({
	root: {
    backgroundColor: theme.palette.common.white,
    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.12)",
    borderRadius: "4px",
  },
  widgetTitle: {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "1.5rem",
    lineHeight: 1.3,
    color: theme.palette.info.main,
  },
  widgetFilters: {
    '& .MuiFormControlLabel-root': {
      lineHeight: 1.5,
      padding: 0,
      margin: 0,
      letterSpacing: 0.15,
    },
    '& .MuiCheckbox-root': {
      padding: 0,
      margin: 0,
    },
  },
}));

export default JobsOverdueWidget;